import _ from "lodash";
import { path } from "../../api";
import * as actions from "../../utils/actions";
import { restClient } from "../../utils/restClient";

const initialState = {
  promotions: [],
  promotion: null,
};

export default {
  namespaced: true,
  name: "promotions",
  state: _.cloneDeep(initialState),
  mutations: {
    [actions.GET_PROMOTIONS](state, payload = []) {
      state.promotions = payload;
    },
    [actions.GET_PROMOTION](state, payload = null) {
      state.promotion = payload;
    },
    [actions.CREATE_PROMOTION](state, payload = null) {
      state.promotion = payload;
    },
    [actions.UPDATE_PROMOTION](state, payload = null) {
      state.promotion = payload;
    },
    [actions.RESET_PROMOTION_FORM](state) {
      state.promotion = null;
    },
  },
  actions: {
    async fetchPromotions({ commit }, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.promotions.base,
            "GET",
            null,
            payload
          );
          commit(actions.GET_PROMOTIONS, response.data.data);
          resolve(response);
        } catch (error) {
          commit(actions.GET_PROMOTIONS, []);
          reject(error);
        }
      });
    },
    async fetchPromotion({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await restClient(
            path.admin.promotions.single(payload),
            "GET"
          );
          commit(actions.GET_PROMOTION, data);
          resolve(data);
        } catch (error) {
          commit(actions.GET_PROMOTION, null);
          reject(error);
        }
      });
    },
    async createPromotion({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.promotions.base,
            "POST",
            payload
          );
          commit(actions.CREATE_PROMOTION, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async updatePromotion({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.promotions.single(payload.id),
            "PUT",
            payload
          );
          commit(actions.UPDATE_PROMOTION, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deletePromotion(_, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.promotions.single(payload),
            "DELETE"
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    resetForm({ commit }) {
      commit(actions.RESET_PROMOTION_FORM);
    },
    async applyPromotionToUsers(_, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            `${path.admin.promotions.single(payload.id)}/apply-to-users`,
            "POST",
            { user_ids: payload.userIds }
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
